export const getImageSrc = (imageUrl, options = {}) => {
  const { fallback = '', base = process.env.PUBLIC_URL || '' } = options;

  if (!imageUrl) return fallback;
  if (base && imageUrl.startsWith(base)) return imageUrl;
  if (imageUrl.startsWith('http')) return imageUrl;
  if (imageUrl.startsWith('/')) return `${base}${imageUrl}`;
  return `${base}/${imageUrl}`;
};
